import { render, staticRenderFns } from "./DisplayDemands.vue?vue&type=template&id=64491b6e&scoped=true&"
import script from "./DisplayDemands.vue?vue&type=script&lang=js&"
export * from "./DisplayDemands.vue?vue&type=script&lang=js&"
import style0 from "./DisplayDemands.vue?vue&type=style&index=0&id=64491b6e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64491b6e",
  null
  
)

export default component.exports